import { AdhocItem } from "./adhoc-items.model";
import { BonusItem } from "./bonus-items.model";
import { DeductionItem } from "./deduction-items.model";
import { OtherAdditionItem } from "./other-addition-items.model";
import { OtherDeductionItem } from "./other-deduction-items.model";
import { User } from "./user.model";

export interface GetPayslipUserResult {
  user: {
    id: number;
    email: string;
    fullName: string;
    createdAt?: Date;
    updatedAt?: Date;
    staffInfo: any;
    paymentInfo: any;
    employmentInfo: any;
    role: string;
  };
  processingStatus: ProcessingStatus;
}

export enum ProcessingStatus {
  PROCESSED = "PROCESSED",
  UNPROCESSED = "UNPROCESSED",
  ITEMS_ADDED = "ITEMS_ADDED",
}

export const ProcessingStatusLabels: { [key in ProcessingStatus]: string } = {
  [ProcessingStatus.PROCESSED]: "Processed",
  [ProcessingStatus.UNPROCESSED]: "Unprocessed",
  [ProcessingStatus.ITEMS_ADDED]: "Items Added",
};

export interface Payslip {
  id: number;
  month: number;
  year: number;
  userId: number;
  processingStatus: ProcessingStatus;
  user: User;
  adhocItems: AdhocItem[];
  bonusItems: BonusItem[];
  deductionItems: DeductionItem[];
  otherAdditionItems: OtherAdditionItem[];
  otherDeductionItems: OtherDeductionItem[];
  createdAt?: Date;
  updatedAt?: Date;
  payDate?: Date;
  selfHelpGroupSnapshot? :string;
  basicSalarySnapshot?:  number;
  employeeCpfRateSnapshot?: number;
  employerCpfRateSnapshot?: number;
  cpfTypeSnapshot?: string;
  bankNameSnapshot?: string;
  bankCodeSnapshot?: string;
  branchCodeSnapshot?: string;
  accountNoSnapshot?: string;
}

export interface AggregatePayslip {
  payslipId: number;
  payslipYear: number;
  payslipMonth: number;
  userDetails: {
    id: number;
    name: string;
    designation: string;
    basicSalary: number;
    nric: string;
    employmentStatus: string;
    bankName: string;
    bankAccountNo: string;
    payDate: Date;
    cpfSelfHelpGroup: string;
  };
  basicPay: number;
  payItems: number;
  grossPay: number;
  statutoryDeductions: number;
  ordinaryEmployeeCpfContribution: number;
  selfHelpGroupContribution: number;
  additionalEmployeeCpfContribution: number;
  totalEmployeeCpfContribution: number;
  netPay: number;
  otherItems: number;
  netPayable: number;
  employerCpf: number;
  totalCpf: number;
}
